import { SVGIcon } from '@/components/atoms/Icon/SVGIcon';
import styled from '@emotion/styled';
import { withTheme } from '@innovorder/savory';

export const ModalContent = styled.div`
    padding: ${({ theme }) => theme.savory.spacing[2]} ${({ theme }) => theme.savory.spacing[3]}
        ${({ theme }) => theme.savory.spacing[3]};
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.savory.spacing[3]};
`;

export const FieldLabel = styled.label`
    ${({ theme }) => theme.savory.typography['Body/Bold/Text3']};
    color: ${({ theme }) => theme.savory.colors.neutral[900]};
`;

export const RequiredMark = styled.span`
    color: ${({ theme }) => theme.color.red300};
    margin-left: 2px;
`;

export const FieldGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const InputRow = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const DelayInput = styled.input`
    flex: 1;
    padding: 12px 16px;
    border: 1px solid ${({ theme }) => theme.savory.colors.neutral[200]};
    border-radius: ${({ theme }) => theme.savory.spacing[1]};
    min-width: 430px;
    ${({ theme }) => theme.savory.typography['Body/Regular/Text2']};
    outline: none;

    &:focus {
        border-color: ${({ theme }) => theme.savory.colors.primary[500]};
    }
`;

export const UnitLabel = styled.span`
    ${({ theme }) => theme.savory.typography['Body/Regular/Text3']};
    color: ${({ theme }) => theme.savory.colors.neutral[500]};
    white-space: nowrap;
`;

export const HelperText = styled.span`
    ${({ theme }) => theme.savory.typography['Caption/Regular/Caption1']};
    color: ${({ theme }) => theme.savory.colors.neutral[500]};
`;

export const ButtonContent = styled.span`
    display: flex;
    align-items: center;
    gap: 6px;
    ${({ theme }) => theme.savory.typography['Body/Bold/Text3']};
`;

export const ModalActions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
`;
